<template>
  <div>
    <v-menu absolute max-height="98vh" content-class="v-menu" transition="slide-x-transition">
      <template v-slot:activator="{ on: menu, attrs }">
        <button v-bind="attrs" v-on="menu">
          <v-icon color="#1a1a1a" small>$Colunas</v-icon>
          <span class="ml-2" style="color: #042333">Colunas</span>
        </button>
      </template>

      <v-card style="width: 375px">
        <div
          class="pl-7 cursor-default pb-2 pt-4"
          @click.stop
        >
          <v-btn icon class="cursor-pointer">
            <v-icon
              v-if="todasColunasAtivas"
              color="#142454"
              v-text="'mdi-checkbox-marked'"
              @click="mudarSelecaoDeColuna(false)" />

            <v-icon
              v-else-if="colunasAtivas.length > 0"
              color="#142454"
              v-text="'mdi-minus-box'"
              @click="mudarSelecaoDeColuna" />

            <v-icon v-else v-text="'mdi-checkbox-blank-outline'" @click="mudarSelecaoDeColuna" />
          </v-btn>
          <span v-text="'Todas as colunas'" />
        </div>

        <v-divider />

        <template v-for="(coluna, index) in colunasFinal">
          <div
            :key="index"
            class="pl-4 pr-6 d-flex align-center h-52px"
            :class="{
              'item-sendo-arrastado': coluna === colunaSendoArrastada,
              'cursor-move': coluna.arrastavel
            }"
            :draggable="coluna.arrastavel"
            @dragstart="iniciarArrastoItem(coluna)"
            @dragleave="arrastandoItem(coluna)"
            @dragend="finalizarArrastoItem"
            @click.stop
          >
            <v-icon x-small v-text="'mdi-format-list-bulleted'" />

            <v-btn icon class="cursor-pointer" @click="ativarColuna(coluna)">
              <v-icon v-if="coluna.ativa" color="#142454" v-text="'mdi-checkbox-marked'" />
              <v-icon v-else v-text="'mdi-checkbox-blank-outline'" />
            </v-btn>

            <span class="mr-5 font-16" v-text="coluna.text" />
          </div>

          <div :key="`${index}_`">
            <v-divider v-if="!(coluna === colunaSendoArrastada)" class="mr-10" />
            <v-divider v-else class="divider-item-arrastavel" />
          </div>
        </template>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
const TEMPO_MINIMO_PARA_ORDENACAO = 10;

export default {
  name: "Colunas",
  props: {
    headers: Array
  },
  data: () => ({
    colunas: [],
    colunaSendoArrastada: null,
    tempoAtualizacaoColunasTabela: null
  }),
  computed: {
    colunasFinal() {
      return this.colunas.filter(col => col.arrastavel);
    },
    colunasAtivas() {
      return this.colunas.filter(col => col.ativa && col.arrastavel);
    },
    todasColunasAtivas() {
      return this.colunasAtivas.length === this.colunasFinal.length;
    }
  },
  watch: {
    headers: {
      handler () {
        if (this.colunas.length > 0) return;
        this.colunas = this.headers.map(item => Object.assign({}, item));
      },
      immediate: true
    }
  },
  methods: {
    iniciarArrastoItem(coluna) {
      this.colunaSendoArrastada = coluna;
    },
    arrastandoItem(coluna) {
      clearTimeout(this.tempoAtualizacaoColunasTabela);

      this.tempoAtualizacaoColunasTabela = setTimeout(() => {
        const index = this.colunas.indexOf(coluna);
        this.colunas = this.colunas.filter(col => col !== this.colunaSendoArrastada);
        this.colunas.splice(index, 0, this.colunaSendoArrastada);
      }, TEMPO_MINIMO_PARA_ORDENACAO)
    },
    finalizarArrastoItem() {
      setTimeout(() => {
        this.colunaSendoArrastada = null;
        this.atualizarColunasTabela();
      }, TEMPO_MINIMO_PARA_ORDENACAO)
    },
    mudarSelecaoDeColuna(ativa = true) {
      this.colunas.map(coluna => {
        if (coluna.fixa) {
          return coluna;
        }
        coluna.ativa = ativa;
        return coluna;
      })

      this.atualizarColunasTabela();
    },
    ativarColuna(coluna) {
      coluna.ativa = !coluna.ativa;
      this.atualizarColunasTabela();
    },
    atualizarColunasTabela() {
      this.$emit("atualizacao:colunas-tabela", this.colunas.filter(col => col.ativa));
    }
  }
}
</script>

<style scoped>
.item-sendo-arrastado {
  background: #F0FDFF;
  margin: -2px 10px 1px -5px;
}
.divider-item-arrastavel {
  border-bottom: 3px solid #2D9CDB;
}
.h-52px {
  height: 52px;
}
.v-menu {
  border-top: 1px solid #2D9CDB;
  border-left: 1px solid #2D9CDB;
}
</style>
